import React from 'react';
import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Sarah Thibodaux',
      location: 'New Orleans, LA',
      rating: 5,
      text: 'PureAir saved us during a brutal Louisiana summer! Our AC died on a Friday night and they had someone out within 2 hours. Incredible service and fair pricing.',
      service: 'AC Repair',
    },
    {
      name: 'James Landry',
      location: 'Metairie, LA',
      rating: 5,
      text: 'Best HVAC company we\'ve ever worked with. They installed our new system and the team was professional, clean, and efficient. Highly recommend!',
      service: 'Heating Installation',
    },
    {
      name: 'Emily Broussard',
      location: 'Slidell, LA',
      rating: 5,
      text: 'The maintenance plan has been a game-changer. No more surprise breakdowns and our energy bills have dropped significantly. Great investment!',
      service: 'Maintenance Plan',
    },
    {
      name: 'Michael Guidry',
      location: 'Kenner, LA',
      rating: 5,
      text: 'After the duct cleaning, the air quality in our home improved dramatically. My allergies have never been better. Great service!',
      service: 'Duct Cleaning',
    },
  ];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-sm font-medium tracking-wide uppercase text-[#0EA5E9] mb-4">
            Customer Reviews
          </p>
          <h2
            data-testid="testimonials-headline"
            className="text-4xl md:text-5xl font-bold text-[#0F172A] mb-6"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            What Our Customers Say
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Don't just take our word for it. Here's what homeowners like you have
            experienced through our network.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              data-testid={`testimonial-card-${index}`}
              className="testimonial-card bg-[#F8FAFC] p-8 md:p-10 rounded-3xl border border-slate-100 relative"
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-8 opacity-10">
                <Quote className="w-16 h-16 text-[#0EA5E9]" />
              </div>

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-[#F97316] text-[#F97316]"
                  />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-slate-700 leading-relaxed mb-6 relative z-10">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#0F172A]">{testimonial.name}</p>
                  <p className="text-sm text-slate-500">{testimonial.location}</p>
                </div>
                <div className="bg-[#0EA5E9]/10 text-[#0EA5E9] text-sm font-medium px-3 py-1 rounded-full">
                  {testimonial.service}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Rating Summary */}
        <div
          data-testid="rating-summary"
          className="mt-12 text-center"
        >
          <div className="inline-flex items-center gap-3 bg-[#F8FAFC] px-6 py-4 rounded-2xl border border-slate-100">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-6 h-6 fill-[#F97316] text-[#F97316]"
                />
              ))}
            </div>
            <div className="h-8 w-px bg-slate-200" />
            <div className="text-left">
              <p className="font-bold text-[#0F172A]">4.9 out of 5</p>
              <p className="text-sm text-slate-500">Based on 500+ reviews</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
